import ThemedLayout from 'components/atoms/ThemedLayout'
import i18n from 'utils/i18n'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import React from 'react'
import TravelHistoryView from 'components/atoms/TavelHistoryView'

const HomeMoreTravelHistoryProfileEditScene = () => {
	
	
	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				topNavigation={ true }
				showBackButton={ true }
				footerBar={ true }
				title={ i18n.t( 'titles.more_travel_history') }>
				
				<TravelHistoryView />
				<TravelHistoryView />
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default HomeMoreTravelHistoryProfileEditScene
